module.exports = __webpack_public_path__ + "static/media/Media1.5953e384.jpg";